<template>

	<div class="fc">

		<img :src="result.imagem" class="battery">
		<h2 :class="result.class">{{porcentagem}}%</h2>
		<h2 :class="result.class">Seu nível de atenção é: {{result.titulo}}</h2>

		<br>
		<br>
		
		<div>
			<p v-html="result.mensagem"></p>
			<br>
			<p>O diagnóstico resumido fornece a visualização rápida da situação do seu negócio e do seu conhecimento em gestão. O próximo passo é realizar um diagnóstico completo para a personalização da consultoria de acordo com as necessidades específicas do seu consultório ou clínica. </p>
			<p>Para realizar um diagnóstico completo e obter o plano de ação personalizado, entre em contato clicando no botão abaixo.</p>
		</div>

		<a href="/contato" class="btn-action mt-4">Entrar em contato</a>

	</div>

</template>

<script>

export default {
	name: "Resultado",
	props: ['resultado', 'contato'],
	data () {
		return {
			porcentagem: null,
			newsletter: false,
			isSaved: false,
			critico: {
				titulo: 'Crítico',
				mensagem: 'O seu conhecimento em gestão e o desempenho do seu negócio estão críticos. Procure anular as falhas identificadas com a máxima urgência.',
				imagem: './img/bateria-critico.png',
				class: 'critico'
			},
			preocupante: {
				titulo: 'Preocupante',
				mensagem: 'O seu conheceimento em gestão e o desempenho do seu negócio estão preocupantes. Procure anular os pontos fracos e investir nos pontos fortes do seu negócio. Dê um passo por vez até conseguir o seu objetivo.',
				imagem: './img/bateria-perocupante.png',
				class: 'preocupante'
			},
			regular: {
				titulo: 'Regular',
				mensagem: 'O seu conhecimento em gestão e o desempenho do seu negócio estão regulares. Se você corrigir as falhas e investir nos pontos fortes, vai potencializar muito os resultados. Um bom planejamento, com disciplina e foco, poderá levar você e seu negócio à excelência.',
				imagem: './img/bateria-regular.png',
				class: 'regular'
			},
			bom: {
				titulo: 'Bom a excelente',
				mensagem: 'O seu conhecimento em gestão e o desempenho do seu negócio estão muito bons. Anule os poucos pontos fracos. Invista nos pontos fortes, que são muitos, utilizando-os como referência para ajustar os itens que não estiverem nesse nível de excelência. Isso vai otimizar os resultados.',
				imagem: './img/bateria-bom.png',
				class: 'bom'
			},
			result: null,
		}
	},
	methods: {
		/*onEnviarClick () {
			axios.put('/api/questionarioestatico/' + this.contato.id, {
				newsletter: this.newsletter
			}).then(response => {
				//console.log(response);
				this.isSaved = true;
			}).catch(error => {
				console.log(error.message);
			})
		}*/
	},
	created () {
		this.porcentagem = (this.resultado * 100)/40; console.log(this.porcentagem);

		if (this.porcentagem <= 30)
			this.result = this.critico;
		if (this.porcentagem <= 50 && this.porcentagem > 30)
			this.result = this.preocupante;
		if (this.porcentagem <= 70 && this.porcentagem > 50)
			this.result = this.regular;
		if (this.porcentagem >= 71)
			this.result = this.bom;
	}
}
</script>

<style scoped>

</style>
